import React from 'react'
import { provincesContext } from './context';
import { ProvincesProvider } from './provider';

const useProvinces = () => {
  const { provinces, options } = React.useContext(provincesContext);
  return { provinces, options };
}

export { useProvinces, ProvincesProvider }
